import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ru from "../language/RU_ru.json";
import en from "../language/EN_en.json";


export const resources = {
  ru: {
    translation: ru.data
  },
  en: {
    translation: en.data
  }
  
};

// Получаем язык из localStorage
const savedLanguage = localStorage.getItem("appLanguage");

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage || "ru", 
    fallbackLng: "ru",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;